import { render, staticRenderFns } from "./matrim_fill.vue?vue&type=template&id=21e2673e&scoped=true"
import script from "./matrim_fill.vue?vue&type=script&lang=js"
export * from "./matrim_fill.vue?vue&type=script&lang=js"
import style0 from "./matrim_fill.vue?vue&type=style&index=0&id=21e2673e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2673e",
  null
  
)

export default component.exports